import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

export const loginClient = (FormData, navigate, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post("/client/login", FormData, {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      if (res.data.message === "Login successful") {
        toast.success(res.data.message);
        secureStorage.setItem("clientToken", res.data.accessToken);
        secureStorage.setItem("client", JSON.stringify(res.data.company));
        window.location.replace("/client/dashboard");
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      setIsLoading(false);
    });
};
